import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ApiConfig } from "@/config/api.config";
import { ApiHookProps } from '@/@types/api.types';
import { GetHotelListItemDtoListResponseDto } from '@/features/hotels/types/hotels-dto';
import {useAxiosAuth} from "@/hooks/useAxiosAuth.ts";

type Props = {} & ApiHookProps;

export const useHotelsListApi = ({}: Props = {}) => {
    const axiosInstance = useAxiosAuth();
    const queryClient = useQueryClient();

    const {
        data: hotelsListData, 
        isLoading: isLoadingHotelsListData, 
        isError: isErrorHotelsListData,
    } = useQuery({
        queryKey: [
            ApiConfig.queries.features.hotels.queryKeys.list
        ],
        queryFn: async (): Promise<GetHotelListItemDtoListResponseDto> => {
            const url = ApiConfig.queries.features.hotels.endpoints.list;
            const response = await axiosInstance.get<GetHotelListItemDtoListResponseDto>(url);
            return response.data;
        },     
    });

    const doRefresh = async () => {
        await queryClient.invalidateQueries({
            queryKey:[ApiConfig.queries.features.hotels.queryKeys.apiRefresh]
        })
    };

    return {
        hotelsListData,
        isLoadingHotelsListData,
        isErrorHotelsListData,
        doRefresh
    }
};
